import React from "react";
import "./card-row.css";

/** Placeholder row shown while the cards list is loading. Mirrors CardRow's
 * grid so the skeletons line up with the real rows once they arrive. */
function CardRowSkeleton() {
  return (
    <div className="cr-row cr-row--skeleton" aria-hidden="true">
      <span className="cr-skeleton-bar cr-skeleton-bar--num" />
      <span className="cr-skeleton-bar cr-skeleton-bar--bal" />
      <span className="cr-skeleton-bar cr-skeleton-bar--status" />
      <div className="cr-actions">
        <span className="cr-skeleton-bar cr-skeleton-bar--btn" />
        <span className="cr-skeleton-bar cr-skeleton-bar--btn" />
      </div>
    </div>
  );
}

export default CardRowSkeleton;
